import React, { PropTypes } from 'react';
import { FormControl, Col, ControlLabel, FormGroup } from 'react-bootstrap';

const CoverNoteNo = (props) => {
  return (
    <FormGroup controlId="coverNoteNo">
      <Col componentClass={ControlLabel} sm={4}>
        Cover Note Number
      </Col>
    <Col sm={8}>
        <FormControl type="text"
          value={props.coverNoteNo} onChange={props.handleChangeCoverNoteNo}
          autoComplete="off" />
    </Col>
    </FormGroup>
  )
}

CoverNoteNo.propTypes = {
  coverNoteNo: PropTypes.string,
  handleChangeCoverNoteNo: PropTypes.func
};

export default CoverNoteNo;



// WEBPACK FOOTER //
// ./src/app/components/retrieveCoverNoteComponent/coverNoteNo/CoverNoteNo.js